import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from "react";

const SystemConfigurationTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  selectedRow,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");

  const [isClickable, setIsClickable] = useState(false);

  useEffect(() => {
    setIsClickable(selectedRow?.formikData?.values?.need_action);
  }, [selectedRow?.formikData?.values?.need_action]);

  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("system_configuration.title"),
            createBtnTitle: "",
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "key",
                Header: t("system_configuration.key"),
                sort: true,
              },
              {
                accessor: "value",
                Header: t("system_configuration.value"),
                sort: true,
              },
              {
                accessor: "description",
                Header: t("system_configuration.description"),
                sort: true,
              },
              {
                accessor: "created_at",
                Header: t("details.created_at"),
              },
              {
                accessor: "updated_at",
                Header: t("details.updated_at"),
              },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: "",
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id
              ? { is_visible: false, need_action: false }
              : initialValues(details, supportedLang),
            structure: () => structure(supportedLang, isClickable, t),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id
              ? t("system_configuration.edit")
              : t("system_configuration.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default SystemConfigurationTemplate;
